import { render, staticRenderFns } from "./AcceptableUsePolicy.vue?vue&type=template&id=f01b63a2&"
import script from "./AcceptableUsePolicy.vue?vue&type=script&lang=js&"
export * from "./AcceptableUsePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports